import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-state-players',
  templateUrl: './state-players.component.html',
  styleUrls: ['./state-players.component.scss']
})
export class StatePlayersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
